<template>
  <div class="data-export-container">
    <div class="header">
      <p>数据导出</p>
      <div class="common-button-box btn-group-primary">
        <el-button
          class="normal-btn gr8"
          v-if="isChecked('Data.Migration.ExportPublish.List')"
          size="small"
          @click="openPublishRecordDialog">
          <div class="btn-list">
            <icon-svg
              icon-class="ic-fabujilu"
              size="14"
              class="icon gr4" />
            发布记录
          </div>
        </el-button>
        <el-button
          class="normal-btn"
          v-if="isChecked('Data.Migration.ExportPublish.PlatformList')"
          size="small"
          @click="openPlatFormManageDialog">
          <div class="btn-list">
            <icon-svg
              size="14"
              icon-class="ic-fabupingtaiguanli"
              class="icon gr4" />
            发布平台管理
          </div>
        </el-button>
      </div>
    </div>
    <div class="operate-area-box">
      <div class="common-button-box">
        <el-button
          v-if="isChecked('Data.Migration.Export.Export')"
          class="primary-btn text-center gr8"
          type="primary"
          size="small"
          @click="openExportDialog"
          >导出</el-button
        >
        <el-button
          v-if="isChecked('Data.Migration.ExportPublish.BatchPublish')"
          class="primary-btn gr8"
          type="primary"
          size="small"
          @click="publishProj"
          >项目发布</el-button
        >
        <el-button
          v-if="isChecked('Data.Migration.ExportPublish.BatchPublish')"
          class="primary-btn gr8"
          type="primary"
          size="small"
          @click="batchPublish"
          >批量发布</el-button
        >
        <div class="common-dropdown-box">
          <el-dropdown
            placement="bottom-start"
            @command="batchOperate">
            <el-button
              size="small"
              class="normal-btn">
              <span>批量操作</span>
              <i class="el-icon-arrow-down"></i>
            </el-button>
            <el-dropdown-menu
              slot="dropdown"
              class="dropdown-menu dropdown-primary"
              :append-to-body="false">
              <el-dropdown-item
                command="1"
                v-if="isChecked('Data.Migration.Export.BatchDownload')"
                >批量下载</el-dropdown-item
              >
              <el-dropdown-item
                command="2"
                v-if="isChecked('Data.Migration.Export.BatchDelete')"
                >批量删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="filter-box">
        <div class="filter-item-box gr24">
          <div class="name gr8 searchLabel">所属项目:</div>
          <div class="common-select-box proj-select-box">
            <el-select
              class="primary-select"
              size="small"
              filterable
              remote
              clearable
              :remote-method="filterProj"
              :loading="filterProjLoading"
              :popper-append-to-body="false"
              v-model="projId"
              @change="handleProjChange">
              <template slot="prefix">
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-search"></i>
              </template>
              <div>
                <el-option
                  v-if="!filterProjName"
                  value="all"
                  label="所有"></el-option>
                <el-option
                  v-for="(item, index) in projList"
                  :key="index"
                  :label="item.projectName"
                  :value="item.projectId" />
              </div>
            </el-select>
          </div>
        </div>
        <div class="filter-item-box gr24">
          <div class="name gr8 searchLabel">数据类型:</div>
          <div class="common-select-box">
            <el-cascader
              v-if="showCascader"
              class="primary-select"
              size="small"
              :append-to-body="false"
              popper-class="common-cascader-box"
              :options="dataTypeOptions"
              v-model="dataType"
              @change="handleCascaderChange"
              @visible-change="visibleChange" />
          </div>
        </div>
        <div class="filter-item-box gr24">
          <div class="name gr8 searchLabel">导出状态:</div>
          <div class="common-select-box">
            <el-select
              class="primary-select"
              size="small"
              :popper-append-to-body="false"
              v-model="status"
              @change="handleStatusChange">
              <el-option
                value="all"
                label="所有"></el-option>
              <el-option
                :value="2"
                label="排队中"></el-option>
              <el-option
                :value="0"
                label="导出中"></el-option>
              <el-option
                :value="1"
                label="导出成功"></el-option>
              <el-option
                :value="-1"
                label="导出失败"></el-option>
            </el-select>
          </div>
        </div>
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            placeholder="请输入名称搜索"
            v-model="name"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
      </div>
    </div>
    <div class="export-data-box">
      <div v-if="loading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        class="common-table-box"
        v-if="dataList.length && !loading">
        <el-table
          class="publish-table"
          height="100%"
          highlight-selection-row
          :header-row-class-name="customHeader"
          ref="modelTable"
          row-key="id"
          :data="dataList"
          @select="selectChange"
          @select-all="selectChange">
          <el-table-column
            type="selection"
            width="60"
            :reserve-selection="true" /><el-table-column
            label="序号"
            type="index"
            width="55"></el-table-column>
          <el-table-column
            label="名称/大小"
            width="280">
            <template v-slot="{ row }">
              <div
                class="text-overflow"
                :title="row.name">
                {{ row.name }}
              </div>
              <div>
                {{
                  `${formatFileSize(row.length).fileSize}${
                    formatFileSize(row.length).unit
                  }`
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数据类型">
            <template v-slot="{ row }">
              <span>{{ getDataType(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="资源类型">
            <template v-slot="{ row }">
              <span v-if="row.resourceType === 0">Windows</span>
              <span v-if="row.resourceType === 1">MinIO</span>
              <span v-if="row.resourceType === -1">--</span>
            </template>
          </el-table-column>
          <el-table-column
            label="导出状态"
            width="150">
            <template v-slot="{ row }">
              <div
                v-if="row.status === -1"
                class="status-box">
                <div class="circle bg-color3"></div>
                <span class="color3">导出失败</span>
                <el-tooltip
                  :effect="$theme.tooltipKey()"
                  placement="top-start"
                  popper-class="common-panel-tooltip-box">
                  <div
                    slot="content"
                    class="content-box">
                    {{ row.failReason }}
                  </div>
                  <div class="icon-box">
                    <i class="el-icon-warning"></i>
                  </div>
                </el-tooltip>
                <icon-svg
                  title="重新导出"
                  class="icon"
                  icon-class="ic-zaicijiexi"
                  @click.native="reExport(row)" />
              </div>
              <div
                class="common-progress-box"
                v-if="row.status === 0">
                <el-progress
                  :show-text="false"
                  :percentage="row.progress" />
                <div class="custom-text">
                  <div class="text">{{ `${row.progress}%` }}</div>
                </div>
              </div>
              <div
                v-if="row.status === 1"
                class="status-box">
                <div class="circle bg-color4"></div>
                <span class="color4">导出成功</span>
              </div>
              <div
                v-if="row.status === 2"
                class="status-box">
                <div class="circle bg-color2"></div>
                <span class="color2">排队中</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="所属项目">
            <template v-slot="{ row }">
              <span
                class="text-overflow"
                :title="row.projectName"
                >{{ row.projectName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="创建人">
            <template v-slot="{ row }">
              <span
                class="text-overflow"
                :title="row.creatorName"
                >{{ row.creatorName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间/完成时间"
            width="200">
            <template v-slot="{ row }">
              <div>{{ formatTime(row.creationTime) }}</div>
              <div v-if="row.status === 1">
                {{
                  row.finishTime
                    ? formatTime(row.finishTime)
                    : formatTime(row.creationTime)
                }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="isChecked('Data.Migration.Export.Download')"
                  type="text"
                  size="small"
                  @click="downloadById(row)"
                  :disabled="row.status !== 1"
                  >下载</el-button
                >
                <el-button
                  v-if="isChecked('Data.Migration.ExportPublish.Publish')"
                  type="text"
                  size="small"
                  @click="publish(row)"
                  :disabled="row.status !== 1"
                  >发布</el-button
                >
                <el-button
                  v-if="isChecked('Data.Migration.Export.Delete')"
                  type="text"
                  size="small"
                  @click="deleteById(row)"
                  :disabled="row.status === 0 || row.status === 2"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="common-pagination-box pagination-primary">
          <el-pagination
            popper-class="common-pagination-popper-box"
            layout="sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100, 150, 200]"
            :page-size="pageSize"
            :current-page="currPage"
            :total="total"
            @size-change="pageSizeChange"
            @current-change="pageChange">
          </el-pagination>
        </div>
      </div>
      <div
        class="common-empty-box"
        v-if="!dataList.length && !loading">
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <div class="empty-text">抱歉，没有找到相关内容</div>
          </template>
          <!-- <div class="common-button-box">
            <el-button
              type="primary"
              size="small"
              @click="openExportDialog">
              导出
            </el-button>
          </div> -->
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'

import { Store } from '@/utils/store'
import { formatTime, formatFileSize, getTokenId } from '@/utils/generalMethods'

import {
  getExportOptionalProjListService,
  getExportListService,
  deleteExport,
  batchDeleteExport,
  reExportService
} from '@/service/interface'

export default {
  data() {
    return {
      customHeader: '',
      loading: false,
      projId: undefined,
      filterProjLoading: false,
      filterProjName: '',
      projList: [],
      dataType: undefined,
      status: undefined,
      name: '',
      dataList: [],
      selectDatas: [],
      pageSize: 10,
      currPage: 1,
      total: 0,
      dataTypeOptions: [
        { value: 'all', label: '所有' },
        { value: 0, label: '项目信息' },
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'allDataSet', label: '全部' },
            { value: 'Model', label: '模型' },
            { value: 'ModelGroup', label: '模型组' },
            { value: 'Rs', label: '遥感影像' },
            { value: 'Wmts', label: 'WMTS' },
            { value: 'Osgb', label: '倾斜摄影' },
            { value: 'Panorama', label: '360全景图' },
            { value: 'PointCloud', label: '点云' },
            { value: 'Cad', label: '二维图纸' },
            { value: 'Vector', label: '矢量数据' }
          ]
        },
        { value: 1, label: '场景' }
      ],
      showCascader: true
    }
  },
  props: {
    openExportDialog: Function,
    openPublishRecordDialog: Function,
    openPlatFormManageDialog: Function,
    updatePublishInfo: Function,
    openPublishDialog: Function,
    openProjPublishDialog: Function
  },
  components: {
    Spin
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const currentBody = this.$refs.modelTable?.bodyWrapper
        console.log(this.$refs, 'bodu')
        currentBody &&
          currentBody.addEventListener('scroll', ev => {
            const scrollTop = ev.target.scrollTop
            this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
          })
      }, 500)
    })
    this.initProjList()
    this.initExportList()
    this.$eventManage.on('updateExportlist', this.initExportList)
  },
  beforeDestroy() {
    this.$eventManage.off('updateExportlist', this.initExportList)
  },
  methods: {
    initProjList() {
      getExportOptionalProjListService({}).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    filterProj(filterName) {
      this.filterProjName = filterName
      this.filterProjLoading = true
      getExportOptionalProjListService({ projectName: filterName }).then(
        response => {
          if (response.isSuccess) {
            let projList = response.data
            this.projList = projList
            this.filterProjLoading = false
          } else {
            this.$message.error(response.errMsg)
          }
        }
      )
    },
    initExportList() {
      this.loading = true
      this.queryExportList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        this.timer && clearInterval(this.timer)
        let exportingStatus = [0, 2]
        let exportingData = dataList.filter(el =>
          exportingStatus.includes(el.status)
        )
        if (exportingData.length) {
          this.timer = setInterval(this.refreshExportList, 5 * 1000)
        }

        this.loading = false
      })
    },
    handleProjChange(value) {
      this.currPage = 1
      this.filterProjName = ''
      if (!value) {
        this.projId = 'all'
      }
      this.initExportList()
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    handleCascaderChange(dataType) {
      if (dataType.length === 1) {
        let value = dataType[0]
        this.exportType = value
      }
      if (dataType.length === 2) {
        let value = dataType[1]
        this.exportType = value
      }
      this.currPage = 1
      this.initExportList()
    },
    handleStatusChange() {
      this.currPage = 1
      this.initExportList()
    },
    search() {
      this.currPage = 1
      this.initExportList()
    },
    downloadById(exportInfo) {
      this.downloadFiles([exportInfo])
    },
    deleteById(exportInfo) {
      this.$confirm(
        '该操作将会删除资源包文件，并清除该条记录，确认要删除吗?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          let id = exportInfo.id
          deleteExport(id).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')
              this.currPage = 1
              this.initExportList()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    reExport(exportInfo) {
      let id = exportInfo.id
      reExportService(id).then(response => {
        if (response.isSuccess) {
          this.$message.success('开始重新导出')
          this.refreshExportList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    selectChange(selection) {
      this.selectDatas = selection
    },
    refreshExportList() {
      this.queryExportList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        let exportingStatus = [0, 2]
        let exportingData = dataList.filter(el =>
          exportingStatus.includes(el.status)
        )
        if (exportingData.length) {
          this.timer && clearInterval(this.timer)
          this.timer = null
          this.timer = setInterval(this.refreshExportList, 5 * 1000)
        } else {
          this.timer && clearInterval(this.timer)
          this.timer = null
        }
      })
    },
    publish(exportInfo) {
      let publishInfo = { exportDatas: [exportInfo] }
      this.updatePublishInfo(publishInfo)
      this.openPublishDialog()
    },
    publishProj() {
      this.openProjPublishDialog()
    },
    batchPublish() {
      if (!this.selectDatas.length) {
        this.$message.warning('请选择需要发布的数据')
        return
      }

      let publishInfo = {
        exportDatas: this.selectDatas
      }
      this.updatePublishInfo(publishInfo)
      this.openPublishDialog()
    },
    batchOperate(command) {
      switch (command) {
        case '1':
          this.batchDownlod()
          break
        case '2':
          this.batchDelete()
          break
      }
    },
    pageSizeChange(pageSize) {
      this.currPage = 1
      this.pageSize = pageSize
      this.initExportList()
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.initExportList()
    },
    batchDownlod() {
      if (!this.selectDatas.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      let validDatas = this.selectDatas.filter(el => el.status === 1)
      this.downloadFiles(validDatas)
    },
    batchDelete() {
      if (!this.selectDatas.length) {
        this.$message.warning('请先勾选文件')
        return
      }

      let inValidDatas = this.selectDatas.filter(el => el.status === 0)
      if (inValidDatas.length) {
        let fileNames = inValidDatas.map(el => el.name)
        let msgTail = '正在导出中，不能删除！'
        let errMsg = this.getExceptionMessage(fileNames, msgTail)
        this.$message.error(errMsg)
      }

      let validDatasets = this.selectDatas.filter(el => el.status !== 0)
      if (validDatasets.length) {
        let ids = validDatasets.map(el => el.id)
        this.$confirm('确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            batchDeleteExport(ids).then(response => {
              if (response.isSuccess) {
                this.$message.success('删除成功')
                this.currPage = 1
                this.initExportList()
              } else {
                this.$message.error(response.errMsg)
              }
            })
          })
          .catch(() => {
            // this.$message.info('取消删除')
          })
      }
    },
    queryExportList() {
      return new Promise(resolve => {
        let params = this.getQueryParams()
        getExportListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            dataList.forEach(el => {
              el.progress = Number((el.progress * 100).toFixed(2))
            })
            let total = data.totalCount
            resolve({ dataList, total })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getQueryParams() {
      let params = {
        projId: this.projId === 'all' ? undefined : this.projId,
        status: this.status === 'all' ? undefined : this.status,
        name: this.name,
        resultCount: this.pageSize,
        skipCount: (this.currPage - 1) * this.pageSize
      }

      switch (this.exportType) {
        case 'all':
          params.exportType = undefined
          break
        case 0:
        case 1:
          params.exportType = this.exportType
          break
        case 'allDataSet':
          params.exportType = 2
          break
        case 'Model':
          params.exportType = 2
          params.scheme = 'Bim'
          params.formatType = 1
          break
        case 'ModelGroup':
          params.exportType = 2
          params.scheme = 'Bim'
          params.formatType = 2
          break
        case 'Rs':
        case 'Wmts':
        case 'Osgb':
        case 'Panorama':
        case 'PointCloud':
        case 'Cad':
        case 'Vector':
          params.exportType = 2
          params.scheme = this.exportType
          // params.formatType = 1;
          break
      }

      return params
    },
    getDataType(exportInfo) {
      let dataTypeDes = ''
      let exportType = exportInfo.exportType
      let scheme = exportInfo.scheme
      let formatType = exportInfo.formatType
      switch (exportType) {
        case 0:
          dataTypeDes = '项目信息'
          break
        case 1:
          dataTypeDes = '场景'
          break
        case 2:
          if (scheme === 'Bim') {
            if (formatType === 1) {
              dataTypeDes = '模型'
            } else {
              dataTypeDes = '模型组'
            }
          } else if (scheme === 'Rs') {
            dataTypeDes = '遥感影像'
          } else if (scheme === 'Wmts') {
            dataTypeDes = 'WMTS'
          } else if (scheme === 'Osgb') {
            dataTypeDes = '倾斜摄影'
          } else if (scheme === 'Panorama') {
            dataTypeDes = '360全景图'
          } else if (scheme === 'PointCloud') {
            dataTypeDes = '点云'
          } else if (scheme === 'Cad') {
            dataTypeDes = '二维图纸'
          } else if (scheme === 'Vector') {
            dataTypeDes = '矢量数据'
          }
          break
      }
      return dataTypeDes
    },
    downloadFiles(fileData) {
      this.$message({
        message: '开始下载文件，请勿重复操作......',
        type: 'info',
        duration: 3 * 1000
      })

      fileData.forEach((item, index) => {
        let url = ''
        let tokenId = getTokenId()
        if (window.downloadUrl.includes('http')) {
          url = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        } else {
          url = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        }

        this.downloadURL(url, index + 1)
      })
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    getExceptionMessage(files, messageTail) {
      let message = ''
      // 超过两个文件只展示前两个
      if (files.length > 2) {
        let fileNames = `${files[0]}、${files[1]}等${files.length}个文件`
        message = `${fileNames}${messageTail}`
      } else {
        message = `${files}${messageTail}`
      }
      return message
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime,
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.data-export-container {
  height: 100%;
  text-align: left;

  .header {
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
    padding: 0 16px;
    p {
      height: 20px;
      line-height: 10px;
      margin: 5px 0px;
      padding: 4px 10px;
      border-left: 4px solid var(--base-primary-bgColor);
      color: var(--migration-page-title-color);
    }

    .common-button-box {
      .btn-list {
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }

  .operate-area-box {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;

    .common-button-box {
      display: flex;
      .text-center {
        display: flex;
        justify-content: center;
      }
      // .el-button {
      //   width: 90px;
      // }

      .el-button + .el-button {
        margin-left: 0px;
      }

      .common-dropdown-box {
        // :deep(.el-button) {
        //   width: 96px;
        // }
        // .dropdown-menu {
        //   width: 90px;
        // }
      }
    }

    .filter-box {
      display: flex;
      .filter-item-box {
        display: flex;
        // margin-right: 15px;

        .name {
          // color: var(--default-color);
          line-height: 32px;
          white-space: nowrap;
        }

        .common-select-box {
          width: 180px;
          :deep(.el-cascader__dropdown) {
            .el-cascader-menu__wrap {
              height: auto;
            }
            .el-cascader-node {
              height: 26px;
              line-height: 26px;
            }
          }

          :deep(.el-select-dropdown) {
            .el-select-dropdown__item {
              margin-left: 0;
              margin-right: 0;
            }
          }
        }

        .proj-select-box {
          width: 180px;
        }
      }
    }
  }

  .export-data-box {
    margin-top: 16px;
    height: calc(100% - 95px);

    .common-table-box {
      height: 100%;
      padding: 0 16px;

      .publish-table {
        :deep(.el-table__body-wrapper) {
          height: calc(100% - 46px) !important;
        }
      }
      .status-box {
        display: flex;
        font-size: 12px;

        .circle {
          width: 5px;
          height: 5px;
          margin: auto 5px auto 0px;
          border-radius: 50%;
        }

        .icon-box {
          margin: 0px 5px;
          color: var(--base-light-color10);
        }

        .icon {
          cursor: pointer;
        }

        .bg-color1 {
          background: var(--table-cell-status-text-color);
        }

        .bg-color2 {
          background: var(--runing-status-color);
        }

        .bg-color3 {
          background: var(--error-status-color);
        }

        .bg-color4 {
          background: var(--success-status-color);
        }

        .color1 {
          color: var(--table-cell-status-text-color);
        }

        .color2 {
          color: var(--runing-status-color);
        }

        .color3 {
          color: var(--error-status-color);
        }

        .color4 {
          color: var(--success-status-color);
        }
      }

      .common-progress-box {
        display: flex;

        .el-progress {
          width: 40%;
        }

        .custom-text {
          width: 60px;
          line-height: 12px;
          font-size: 12px;
          text-align: center;

          .text {
            color: var(--success-status-color);
          }
        }

        &:hover {
          .custom-text {
            display: block;
          }
        }
      }

      .common-pagination-box {
        text-align: center;
      }
    }

    .common-empty-box {
      color: var(--normal-status-color);
      margin-top: 10px;
      height: calc(100% - 75px);

      .common-button-box {
        .el-button {
          width: 100px;
        }
      }
    }
  }
}
</style>
